"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var DarkMode = function DarkMode(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "dark-mode",
    viewBox: "0 0 13 18"
  }, rest), react_1["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, react_1["default"].createElement("g", {
    transform: "translate(-1215.000000, -128.000000)",
    fill: "#131720",
    fillRule: "nonzero"
  }, react_1["default"].createElement("g", {
    transform: "translate(1206.000000, 121.000000)"
  }, react_1["default"].createElement("g", null, react_1["default"].createElement("g", {
    transform: "translate(9.000000, 7.000000)"
  }, react_1["default"].createElement("path", {
    d: "M4.75,0.9 C3.91313122,0.9 3.10177193,1.02576069 2.31932118,1.2728504 L0.498916587,1.84771501 L2.32087439,2.41763777 C5.17274067,3.30972402 7.15,5.96132028 7.15,9 C7.15,12.0386797 5.17274067,14.690276 2.32087439,15.5823622 L0.498916587,16.152285 L2.31932118,16.7271496 C3.10177193,16.9742393 3.91313122,17.1 4.75,17.1 C9.22137085,17.1 12.85,13.4713708 12.85,9 C12.85,4.52862915 9.22137085,0.9 4.75,0.9 Z M4.505,2.106 L4.75,2.1 C8.55862915,2.1 11.65,5.19137085 11.65,9 L11.6459962,9.23708392 C11.5208816,12.9360945 8.47928271,15.9 4.75,15.9 L4.505,15.894 L4.59940932,15.8360675 C6.88330403,14.3836375 8.35,11.8351592 8.35,9 L8.34544315,8.72655186 C8.25452409,6.00156333 6.80963001,3.56950988 4.59940932,2.16393248 L4.505,2.106 Z"
  })))))));
};

exports["default"] = DarkMode;